/* heading1:
 *
 * Turn top label into heading level 1.
 *
 * Author: Niels Giesen
 * Copyright 2016 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  var level = 1;

  $(function () {
    $(doc).on("bb:preHandleData", function (event, data) {
      if (data && data.groups && data.groups.length) {
        $.each(data.groups, function (_, group) {
          if (
            group.controls &&
            group.controls[0] &&
            group.controls[0].controltype === "label"
          )
            group.controls[0]._subtype = "heading";
          group.controls[0]._level = level;
        });
      }
    });
  });
})(jQuery, window, document);
